if (!customElements.get('profile-details')) {
  customElements.define(
    'profile-details',
    class ProfileDetails extends HTMLElement {
      constructor() {
          super();
          this.contentEle = null;
          this.readMoreEle = null;
      }

      handleClick() {
        if (this.contentEle.classList.contains("closed")) {
          this.readMoreEle.textContent = "Read less -";
          this.contentEle.classList.remove("closed");
        } else {
          this.readMoreEle.textContent = "Read more +";
          this.contentEle.classList.add("closed");

        }
      }

      handleLoad() {
        if (this.contentEle.scrollHeight > 120) {
          this.contentEle.classList.add("set-height");
          this.contentEle.classList.add("closed");

          this.readMoreEle = document.createElement('p');
          this.readMoreEle.textContent = "Read more +";
          this.readMoreEle.classList.add("read-more");
          this.readMoreEle.classList.add("primary-body");
          this.readMoreEle.addEventListener("click", this.handleClick.bind(this));

          this.appendChild(this.readMoreEle);
        }
      }

      handleResize() {
        if (this.contentEle.scrollHeight > 120) {
          if (!this.contentEle.classList.contains("set-height")) {
            this.contentEle.classList.add("set-height");
            this.contentEle.classList.add("closed");
  
            this.readMoreEle = document.createElement('p');
            this.readMoreEle.textContent = "Read more +";
            this.readMoreEle.classList.add("read-more");
            this.readMoreEle.classList.add("primary-body");
            this.readMoreEle.addEventListener("click", this.handleClick.bind(this));
  
            this.appendChild(this.readMoreEle);
          }
        } else {
          this.contentEle.classList.remove("set-height");
          this.contentEle.classList.remove("closed");
          this.removeChild(this.readMoreEle);
        }
      }

      connectedCallback() {
        this.contentEle = this.querySelector(".profile-grid__text");
        document.addEventListener("DOMContentLoaded", this.handleLoad.bind(this));
        window.addEventListener("resize", this.handleResize.bind(this));
      }

      disconnectedCallback() {
        document.removeEventListener("DOMContentLoaded", this.handleLoad.bind(this));
        window.removeEventListener("resize", this.handleResize.bind(this));
      }
    }
  );
}